import { createSlice } from "@reduxjs/toolkit";

export const slugDataSlice = createSlice({
    name: "slugData",
    initialState: {
      allSlugData: {},
      progress: '',  
    },
    reducers: {
      allSlugData: (state, action) => {
        state.allSlugData = action.payload;
      },
      setProgress: (state, action) => {
        state.progress = action.payload;
      },
    },
  });
  
  export const { allSlugData, setProgress } = slugDataSlice.actions;
  